<template>
  <div class="privacy-policy">
    <h2>Privacy Policy</h2>
    <p>
      At Passguard9000, we value your privacy and are committed to protecting
      your personal information. Here is how we handle your data:
    </p>
    <ul>
      <li>
        <strong>Local Storage:</strong> All data is encrypted and stored locally
        on your device. We do not transmit or store your data on any external
        servers.
      </li>
      <li>
        <strong>No Tracking:</strong> We do not track or monitor your activities
        within the application.
      </li>
      <li>
        <strong>Optional Feedback:</strong> If you choose to submit feedback
        through the contact form, we will not share or sell your information to
        third parties.
      </li>
      <li>
        <strong>Security:</strong> We employ industry-standard encryption to
        ensure the security of your data within the application.
      </li>
      <li>
        <strong>Third-Party Services:</strong> This application does not
        integrate with third-party services or APIs.
      </li>
    </ul>
    <p>
      For questions about this privacy policy, feel free to contact us at
      <a>support@passguard9000.com</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicyPage",
};
</script>

<style scoped>
.privacy-policy {
  padding: 2rem;
  line-height: 1.6;
  color: #333;

  h2 {
    font-size: 2rem;
    color: var(--primary-color);
    margin-bottom: 1rem;
  }

  ul {
    padding-left: 1.5rem;
    margin: 1rem 0;
    list-style: disc;
  }

  li {
    margin-bottom: 0.5rem;
  }

  a {
    color: var(--primary-color);
    text-decoration: underline;
  }
}
</style>
